import React, { useEffect } from 'react';
import { useRedditAuth } from './RedditAuthContext';
import AdminDashboard from './admin/AdminDashboard';
import RedditorDashboard from './redditor/RedditorDashboard';
import './reddit.css';

export default function RedditLayout() {
  const { user } = useRedditAuth();

  useEffect(() => {
    const prev = document.title;
    document.title = 'Reddit Dashboard';
    return () => { document.title = prev; };
  }, []);

  if (!user) return null;

  return (user.is_admin || user.is_accountant) ? <AdminDashboard /> : <RedditorDashboard />;
}
